import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft, Hammer, LogOut } from "lucide-react";
import { AlrLogo } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { accentFor, phaseForPath } from "@/lib/roles";

const ROLE_HOME_COPY = {
  rental_customer: { eyebrow: "RENTAL CUSTOMER", title: "Laser Safety Officer Training", body: "Your rental LSO course, certificate and status move over in Phase 2." },
  prospect: { eyebrow: "PROSPECT PORTAL", title: "Your franchise journey", body: "Your exploration journey, test-clean video and next steps move over in Phase 5." },
  tour_user: { eyebrow: "GUIDED TOUR", title: "ALR guided tour", body: "The guided tour moves over in Phase 5." },
};

export default function ComingSoon({ roleHome = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const accent = accentFor(user?.role);
  const { phase, label } = phaseForPath(pathname);
  const copy = roleHome ? ROLE_HOME_COPY[user?.role] || ROLE_HOME_COPY.prospect : null;

  return (
    <div className="min-h-screen bg-[#0A0A0A] font-body text-white" data-testid={roleHome ? "role-home-page" : "coming-soon-page"}>
      <div className="alr-grain fixed inset-0 pointer-events-none" />
      <main className="relative mx-auto w-full max-w-2xl px-5 py-10 sm:px-8">
        <div className="mb-12 flex items-center justify-between">
          {roleHome ? <AlrLogo size={56} tint={accent} /> : (
            <button data-testid="coming-soon-back" onClick={() => navigate("/dashboard")} className="flex min-h-[44px] items-center gap-1 text-sm font-bold text-neutral-400 hover:text-white">
              <ChevronLeft size={18} /> Back to dashboard
            </button>
          )}
          <button data-testid="logout-button" onClick={logout} className="flex items-center gap-2 rounded-xl border border-[#333] bg-[#1A1A1A] px-3 py-2 text-xs font-bold hover:border-white/40">
            <LogOut size={16} /> Sign out
          </button>
        </div>
        <div className="alr-rise">
          <p className="text-[11px] font-bold tracking-[0.3em]" style={{ color: accent }}>{copy ? copy.eyebrow : phase ? `ARRIVING IN PHASE ${phase}` : "ARRIVING IN A LATER PHASE"}</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-5xl" data-testid="coming-soon-title">
            {copy ? copy.title : label}
          </h1>
          {roleHome && <p className="mt-4 text-lg text-neutral-300" data-testid="role-home-name">Welcome, {user.full_name || user.email}</p>}
          <div className="mt-8 flex items-start gap-4 rounded-2xl border border-[#333] bg-[#1A1A1A] p-5">
            <Hammer size={22} style={{ color: accent }} className="mt-0.5 shrink-0" />
            <p className="text-sm leading-6 text-neutral-400" data-testid="coming-soon-body">
              {copy ? copy.body : "This screen is being moved from the current portal to the new website. Your data is safe and still available in the current portal until it arrives here."}
              <span className="mt-2 block font-mono text-xs text-neutral-600">{pathname}</span>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
